// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-table-row {
  width: 100%;
  height: fit-content;
  min-height: 13%;
  display: flex;
  flex-direction: row;
  border-bottom: 0.7px solid #DBDBDB;
  justify-content: space-between;
  align-items: self-start;
  padding: 10px 2.2vw;
  gap: 1.5vw;
  place-items: center;
}
.shop-table-row__left {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2vw;
}
.shop-table-row__icon {
  width: 1.5vw;
}
.shop-table-row__info {
  display: flex;
  flex-direction: column;
  gap: 0.75vh;
}
.shop-table-row__info__name {
  color: black;
  font-weight: 500;
  font-size: 0.85rem;
}
.shop-table-row__info__address {
  color: #828282;
  font-size: 0.8rem;
}
.shop-table-row__buttons {
  display: flex;
  flex-direction: row;
  gap: 2vw;
  align-items: center;
}
.shop-table-row__buttons__qr-btn, .shop-table-row__buttons__delete-btn {
  color: #4F4BFF;
  cursor: pointer;
}
.shop-table-row__buttons__menu-btn {
  font-size: 1.25rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/shop-table-row/shop-table-row.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AACR;AACI;EACI,YAAA;AACR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAAR;AACQ;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;AACZ;AACQ;EACI,cAAA;EACA,iBAAA;AACZ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAAR;AACQ;EAEI,cAAA;EACA,eAAA;AAAZ;AAEQ;EACI,kBAAA;EACA,eAAA;AAAZ","sourcesContent":[".shop-table-row{\n    width: 100%;\n    height: fit-content;\n    min-height: 13%;\n    display: flex;\n    flex-direction: row;\n    border-bottom: 0.7px solid #DBDBDB;\n    justify-content: space-between;\n    align-items: self-start;\n    padding: 10px 2.2vw;\n    gap: 1.5vw;\n    place-items: center;\n\n    &__left{\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        gap: 2vw;\n    }\n    &__icon{\n        width: 1.5vw;\n    }\n\n    &__info{\n        display: flex;\n        flex-direction: column;\n        gap: 0.75vh;\n        &__name{\n            color: black;\n            font-weight: 500;\n            font-size: 0.85rem;\n        }\n        &__address{\n            color: #828282;\n            font-size: 0.8rem;\n        }\n    }\n    &__buttons{\n        display: flex;\n        flex-direction: row;\n        gap: 2vw;\n        align-items: center;\n        &__qr-btn,\n        &__delete-btn{\n            color: #4F4BFF;\n            cursor: pointer;\n        }\n        &__menu-btn{\n            font-size: 1.25rem;\n            cursor: pointer;\n        }\n    }\n   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
